@if (showIcon) {
  <svg-icon class="w-5 h-3" [src]="'show_n-a'"></svg-icon>
}

<app-dropdown-control
  *ngVar="selectedFilterOption$ | async as selectedFilterOption"
  data-test-id="thread-filter-dropdown"
  class="w-36"
  [class.w-40]="isSelectExpanded"
  [formControl]="control"
  [data]="filterOptions$ | async"
  [displayValueSelector]="displayValueSelector"
  [selectFirstValue]="!selectedFilterOption"
  [selectedValue]="selectedFilterOption"
  (select)="selectOption($event)"
></app-dropdown-control>
